import { useState, useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '@/shared/api';
import type { CallWithDetails } from '@intone/shared';

interface TranslateResponse {
  translation: string
}

export function useTranslator(call: CallWithDetails, campaignLanguage: string = 'en') {
  const apiClient = useApiClient();

  const [translation, setTranslation] = useState<string | undefined>(
    call.transcript_translation || undefined
  )

  const translateMutation = useMutation({
    mutationFn: async (callId: string) => {
      const response = await apiClient<TranslateResponse>('/calls/translate', {
        method: 'POST',
        body: JSON.stringify({ callId }),
      });
      return response.translation;
    },
    onSuccess: (translatedText) => {
      setTranslation(translatedText)
    },
  })

  // Only show translate button if there's no translation and language is not English
  const showTranslate = !translation && campaignLanguage !== 'en'

  const handleTranslate = useCallback(() => {
    if (!call?.id) return
    translateMutation.mutate(call.id)
  }, [call?.id, translateMutation])

  return {
    translation,
    isTranslating: translateMutation.isPending,
    handleTranslate,
    showTranslate,
  }
}